var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnecticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 77,
    viewBox: "0 0 75 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 23.2871C56.0625 23.2557 55.8437 23.2557 55.6562 23.2871C51.3437 23.1299 47.9062 19.5769 47.9062 15.1751C47.9062 10.6788 51.5 7.06299 55.9687 7.06299C60.4375 7.06299 64.0312 10.7103 64.0312 15.1751C64 19.5769 60.5625 23.1299 56.25 23.2871Z",
    stroke: "#1DB0B9",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0309 46.1771C57.3122 46.9003 62.0309 46.1456 65.3434 43.9133C69.7497 40.9577 69.7497 36.1156 65.3434 33.1601C61.9997 30.9278 57.2184 30.1731 52.9372 30.9278",
    stroke: "#1DB0B9",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 23.2871C18.8437 23.2557 19.0624 23.2557 19.2499 23.2871C23.5624 23.1299 26.9999 19.5769 26.9999 15.1751C26.9999 10.6788 23.4062 7.06299 18.9374 7.06299C14.4687 7.06299 10.8749 10.7103 10.8749 15.1751C10.9062 19.5769 14.3437 23.1299 18.6562 23.2871Z",
    stroke: "#1DB0B9",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8748 46.1771C17.5936 46.9003 12.8748 46.1456 9.56232 43.9133C5.15607 40.9577 5.15607 36.1156 9.56232 33.1601C12.9061 30.9278 17.6873 30.1731 21.9686 30.9278",
    stroke: "#1DB0B9",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 46.7745C37.3125 46.7431 37.0938 46.7431 36.9063 46.7745C32.5938 46.6173 29.1561 43.0643 29.1561 38.6625C29.1561 34.1662 32.75 30.5503 37.2188 30.5503C41.6875 30.5503 45.2813 34.1977 45.2813 38.6625C45.25 43.0643 41.8125 46.6488 37.5 46.7745Z",
    stroke: "#1DB0B9",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4062 56.6788C23.9999 59.6344 23.9999 64.4765 28.4062 67.432C33.4063 70.7964 41.5938 70.7964 46.5938 67.432C51 64.4765 51 59.6344 46.5938 56.6788C41.625 53.346 33.4063 53.346 28.4062 56.6788Z",
    stroke: "#1DB0B9",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecticon);
export default __webpack_public_path__ + "static/media/connecticon.a577465dcc3ebdb33c847ede74a6c5e8.svg";
export { ForwardRef as ReactComponent };